/** 达克矩阵线码 ↔ Hub 虚拟键盘 keycode（仅修饰键；导航/系统键在 V80 矩阵 d 中已是 hub 码） */
const MATRIX_WIRE_TO_HUB: Readonly<Record<number, number>> = {
  104: 224, // LCtrl
  105: 225, // LShift
  106: 226, // LAlt
  107: 227, // LWin
  108: 228, // RCtrl
  109: 229, // RShift
  110: 230, // RAlt
  3: 61697, // Fn
};

const HUB_TO_MATRIX_WIRE: Readonly<Record<number, number>> = {
  224: 104,
  225: 105,
  226: 106,
  227: 107,
  228: 108,
  229: 109,
  230: 110,
  61697: 3,
};

export function dakaiMatrixByteToHubKeycode(wire: number): number {
  if (!wire) return wire;
  return MATRIX_WIRE_TO_HUB[wire] ?? wire;
}

export function dakaiHubKeycodeToMatrixByte(hub: number): number {
  if (!hub) return hub;
  return HUB_TO_MATRIX_WIRE[hub] ?? hub;
}
